import { z } from "zod";
export const verifyOtpSchema = z.object({
    email: z.email({ message: "Email is required" }).toLowerCase().trim(),
    code: z.string().length(6, { message: "Code must be 6 digits" }),
    invite_token: z.string().min(1).optional(),
});
